export interface NormalizedFilter {
  column: string;
  values: unknown[];
}

const extractFilterValues = (filter: unknown): unknown[] => {
  const f = filter as {
    values?: unknown;
    conditions?: unknown;
    whereItems?: unknown;
  } | null;

  if (Array.isArray(f?.values)) {
    return f.values;
  }

  if (Array.isArray(f?.conditions)) {
    return f.conditions
      .map((condition) => (condition as { value?: unknown })?.value)
      .filter((value) => value !== undefined && value !== null);
  }

  if (Array.isArray(f?.whereItems)) {
    return f.whereItems
      .map((item) => {
        const condition = (
          item as { condition?: { value?: unknown; values?: unknown } }
        )?.condition;

        return condition?.value || condition?.values || null;
      })
      .flat()
      .filter((value) => value !== undefined && value !== null);
  }

  return [];
};

const extractColumnName = (filter: unknown): string | null => {
  const target =
    (filter as { target?: { column?: string; displayName?: string } })
      ?.target || {};

  return target?.column || target?.displayName || null;
};

export const normalizeFilter = (filter: unknown): NormalizedFilter | null => {
  try {
    const column = extractColumnName(filter);
    const values = extractFilterValues(filter);

    return column ? { column, values } : null;
  } catch (error) {
    console.warn('Error normalizing filter:', error);

    return null;
  }
};
